import React from "react";
import classnames from "classnames";
import styles from "./DesktopMenu.module.scss";
import injectSectionElements from "../injectSectionElements";

const DesktopMenu = ({
  Elements,
  className,
  linkClass,
  itemClass,
  pages,
  menuItems,
  navLinksColor,
}) => {
  return (
    <Elements.NavMenu
      className={classnames({
        [styles.navMenu]: true,
        [className]: className,
      })}
      itemClass={classnames({
        ["nav-item"]: true,
        [styles.navItem]: true,
      })}
      linkClass={classnames({
        ["nav-link"]: true,
        [linkClass]: linkClass,
        [itemClass]: itemClass,
      })}
      itemActive={styles.navItemActive}
      pages={pages}
      menuItems={menuItems}
      navLinksColor={navLinksColor}
    />
  );
};

export default injectSectionElements(DesktopMenu);
